import './App.css';
import Header from './components/Header.js';
import Home from './Home.js';
import Contact from './Contact.js';
import About from './About.js';
import GetToKnowGod from './HowToGetToKnowGod.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App({ totalVisits }) {
    return (
        <div className="App">
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path = '/' element = {<Home totalVisits = { totalVisits }/>} />
                    <Route path = '/contact' element = {<Contact />} />
                    <Route path = '/about' element = {<About />} />
                    <Route path = '/how-to-get-to-know-god' element = {<GetToKnowGod />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;